"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Role = void 0;
/**
 * The possible roles in the appraisal system.
 */
var Role;
(function (Role) {
    Role["Employee"] = "Employee";
    Role["Appraiser"] = "Appraiser";
    Role["HrManager"] = "HR Manager";
    Role["Director"] = "Director";
})(Role = exports.Role || (exports.Role = {}));
//# sourceMappingURL=Role.js.map